// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components"

// COMPONENTS IMPORTS //
import BlockItem from "./BlockItem/BlockItem"
import RowList from "./Shared/RowList/RowList"

import { SkillsList, OtherTechnologies } from "./Data"
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import { Themes, iPhoneResolution } from "Content/Shared/Styles/Theme"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {}

const ProfessionalSkills: React.FC<PropsType> = () => {
  return (
    <>
      {SkillsList.map((skill, index) => (
        <>
          <Title>{skill.title}</Title>
          <BlockItem skill={skill} />
        </>
      ))}

      <Title>Other technologies</Title>
      <BlockItem>
        <RowList list={OtherTechnologies} />
      </BlockItem>
    </>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Title = styled.div`
  font-size: 19px;
  font-weight: bold;
  line-height: 1.5;
  margin-bottom: 10px;
  color: ${Themes.colors.primary};
  filter: brightness(1.1) contrast(1.1);

  @media (max-width: ${iPhoneResolution}px) {
    font-size: 15.5px;
  }
`

export default React.memo(ProfessionalSkills, memoComparison)
